import type { ReactElement } from "react";
import { Skeleton, SkeletonStatus } from "@/components/atoms";
import "./AvailabilityCalendarToolbar.scss";
import "./AvailabilityCalendarSkeleton.scss";

const WEEKDAY_COUNT = 7;
const CALENDAR_ROW_COUNT = 5;
const CALENDAR_CELL_COUNT = WEEKDAY_COUNT * CALENDAR_ROW_COUNT;

const TOOLBAR_CONTROL_HEIGHT = 28;
const TOOLBAR_ICON_SIZE = 29;

/** Loading placeholder matching AvailabilityCalendar week/month shell. */
export function AvailabilityCalendarSkeleton(): ReactElement {
  return (
    <SkeletonStatus
      label="Cargando calendario..."
      className="availability-calendar-skeleton"
    >
      <div className="availability-calendar-toolbar" aria-hidden="true">
        <div className="availability-calendar-toolbar__section availability-calendar-toolbar__section--left">
          <div className="availability-calendar-toolbar__nav">
            <div className="availability-calendar-toolbar__breakpoint--desktop">
              <Skeleton
                width={78}
                height={TOOLBAR_CONTROL_HEIGHT}
                borderRadius="base"
                borderWeight="base"
              />
            </div>
            <div className="availability-calendar-toolbar__breakpoint--mobile">
              <Skeleton
                width={TOOLBAR_ICON_SIZE*1.3}
                height={TOOLBAR_ICON_SIZE}
                borderRadius="base"
                borderWeight="base"
              />
            </div>
            <Skeleton
              width={48}
              height={TOOLBAR_CONTROL_HEIGHT}
              borderRadius="base"
              borderWeight="base"
            />
            <div className="availability-calendar-toolbar__breakpoint--desktop">
              <Skeleton
                width={84}
                height={TOOLBAR_CONTROL_HEIGHT}
                borderRadius="base"
                borderWeight="base"
              />
            </div>
            <div className="availability-calendar-toolbar__breakpoint--mobile">
              <Skeleton
                width={TOOLBAR_ICON_SIZE*1.3}
                height={TOOLBAR_ICON_SIZE}
                borderRadius="base"
                borderWeight="base"
              />
            </div>
          </div>
        </div>
        <div className="availability-calendar-toolbar__section availability-calendar-toolbar__section--center">
          <Skeleton variant="text" width={130} height={20} borderRadius="base" />
        </div>
        <div className="availability-calendar-toolbar__section availability-calendar-toolbar__section--right">
          <div className="availability-calendar-toolbar__mode-selector availability-calendar-toolbar__breakpoint--desktop availability-calendar-skeleton__view-toggle--desktop">
            <Skeleton
              width={76}
              height={TOOLBAR_CONTROL_HEIGHT}
              borderRadius="base"
              borderWeight="base"
            />
            <Skeleton
              width={79}
              height={TOOLBAR_CONTROL_HEIGHT}
              borderRadius="base"
              borderWeight="base"
            />
          </div>
          <div style={{ width: "100%" }} className="availability-calendar-toolbar__breakpoint--mobile">
            <Skeleton
              width={"100%"}
              height={TOOLBAR_CONTROL_HEIGHT}
              borderRadius="base"
              borderWeight="base"
            />
          </div>
        </div>
      </div>

      <div className="availability-calendar-skeleton__grid" aria-hidden="true">
        <div className="availability-calendar-skeleton__header-row">
          {Array.from({ length: WEEKDAY_COUNT }).map((_, index) => (
            <div
              key={`calendar-skeleton-header-${index}`}
              className="availability-calendar-skeleton__header-cell"
            >
              <Skeleton
                variant="text"
                width="70%"
                height={15}
                className="availability-calendar-skeleton__header-label"
              />
            </div>
          ))}
        </div>
        <div className="availability-calendar-skeleton__body">
          {Array.from({ length: CALENDAR_CELL_COUNT }).map((_, index) => (
            <div
              key={`calendar-skeleton-cell-${index}`}
              className="availability-calendar-skeleton__cell"
            />
          ))}
        </div>
      </div>
    </SkeletonStatus>
  );
}
